import isUserRolGuard from "@/guards/isUserRolGuard";

export default [
  {
    path: "dependencia",
    name: "dependencia",
    beforeEnter: isUserRolGuard,
    component: () => import("@/pages/parametros/Dependencia/dependencia.vue"),
  },
  {
    path: "dependencia/nueva",
    name: "dependencia-nueva",
    beforeEnter: isUserRolGuard,
    component: () => import("@/pages/parametros/Dependencia/dependenciaNew.vue"),
  },
  {
    path: "dependencia/:id",
    name: "dependencia-view",
    beforeEnter: isUserRolGuard,
    component: () => import("@/pages/parametros/Dependencia/dependenciaView.vue"),
  },
  {
    path: "dependencia/:id/editar",
    name: "dependencia-edit",
    beforeEnter: isUserRolGuard,
    component: () => import("@/pages/parametros/Dependencia/dependenciaEdit.vue"),
  },
];
